var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-form',{attrs:{"option":_vm.option},on:{"submit":_vm.handleSubmit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }